(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDomainsController', TabDomainsController);

    TabDomainsController.$inject = ['$state', 'TabDomains', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'DataUtils'];

    function TabDomainsController($state, TabDomains, ParseLinks, AlertService, pagingParams, paginationConstants, DataUtils) {
        var vm = this;
        vm.loadPage = loadPage;
        vm.predicates = pagingParams.predicates;
        vm.transition = transition;
        vm.setActive = setActive;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.currentState = "tab-domains";
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder !== null && retrievedOrder !== "null")
            vm.predicates = JSON.parse(retrievedOrder);

        //Aggiunta per impaginazione
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;
        vm.searchText = pagingParams.search;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.loadAll = function () {
            TabDomains.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                search: vm.searchText,
                sort: sort()
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tabDomains = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.searchText,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter
            }, {notify: notify, location: "replace"});
        }

        function setActive(domains, isActivated) {
            domains.isActive = isActivated;
            TabDomains.update(domains, function () {
                vm.loadAll();
                vm.clear();
            });

        }

        function clear() {
            vm.domains = {
                domainName: null,
                domainDescription: null,
                domainCaCrt: null,
                domainClientCrt: null,
                domainClientKey: null,
                isActive: false,
                isVisibile: false,
                id: null
            };
            vm.editForm.$setPristine();
            vm.editForm.$setUntouched();
        }

        vm.loadAll();

        vm.checkLastLog = function (timestamp) {
            var date = new Date();
            var log = new Date(timestamp);
            return log.setDate(log.getDate() + 30) > date;
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
        };
    }
})();
